/*
  One wishlist pop-up at a time.

  Swym can show its "This one's a keeper!" pop-up and its "Added - View" toast
  together, one stacked on top of the other in the bottom corner. Whenever a
  new one appears, any that were already showing are hidden, so only the
  newest is ever on screen.
*/
(function () {
  const TOASTS = [
    '.swym-auto-wishlist-notification',
    'swym-storefront-layout-notification',
    '.swym-wishlist-notifications-container .swym-notification',
  ].join(',');

  let showing = [];

  function visible(el) {
    if (el.classList.contains('magnum-toast-hidden')) return false;
    // Swym keeps an empty 2px holder in the corner between pop-ups; anything
    // that small is not a pop-up on screen. offsetWidth is the pop-up's laid-out
    // size, so one still sliding or growing in already counts at full size.
    return el.offsetWidth > 20 && el.offsetHeight > 20 && getComputedStyle(el).visibility !== 'hidden';
  }

  function check() {
    const now = [...document.querySelectorAll(TOASTS)].filter(visible);
    const fresh = now.filter((el) => !showing.includes(el));
    if (fresh.length && now.length > 1) {
      const keep = fresh[fresh.length - 1];
      now.forEach((el) => {
        if (el === keep) return;
        // The keeper pop-up stays until closed, so it is closed properly.
        const close = el.querySelector('.swym-auto-wishlists-close-icon');
        if (close) close.click();
        el.classList.add('magnum-toast-hidden');
      });
    }
    showing = now.filter(visible);
    // Once nothing is showing, hidden toasts are let go so they can appear again later.
    if (!showing.length) {
      document.querySelectorAll('.magnum-toast-hidden').forEach((el) => el.classList.remove('magnum-toast-hidden'));
    }
  }

  // Only changes that touch a wishlist pop-up matter. Checking on every change
  // anywhere measured each pop-up's size on every frame the sliders moved,
  // which cost a phone over two seconds of work on the product page.
  function touchesToast(record) {
    const el = record.target;
    if (el.nodeType === 1 && (el.closest(TOASTS) || (record.type === 'attributes' && el.querySelector(TOASTS)))) {
      return true;
    }
    for (const node of [...record.addedNodes, ...record.removedNodes]) {
      if (node.nodeType === 1 && (node.matches(TOASTS) || node.querySelector(TOASTS))) return true;
    }
    return false;
  }

  // Swym slides its pop-ups in, so at the moment one is added it can still
  // measure as nothing. It is checked again over the next second and a half,
  // by which time it is fully on screen.
  let queued = false;
  let timers = [];
  function checkSoon() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        check();
      });
    }
    timers.forEach(clearTimeout);
    timers = [150, 400, 800, 1500].map((ms) => setTimeout(check, ms));
  }

  new MutationObserver((records) => {
    if (records.some(touchesToast)) checkSoon();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
})();
